import { Injectable } from "@angular/core";
import { HandlerService } from "../comunicator-native/handler/handler";
import { DataOrigin } from "../../model/DataOrigin";
import { CepDataService } from "./cep-data.service";
import { CepDataMobileService } from "./cep-data-mobile.service";
import { CepMockService } from "./cep-data-mock.service";

@Injectable({
  providedIn: "root",
})
export abstract class CepFactoryService {
  private services = new Map<DataOrigin, CepDataService>();

  constructor(
    private handlerService: HandlerService
  ) {}

  public getService(origin: DataOrigin) {
    if (this.services.has(origin)) {
      return this.services.get(origin);
    } else {
      return this.constructService(origin);
    }
  }

  private constructService(origin: DataOrigin): CepDataService {
    switch (origin) {
      case DataOrigin.Mobile:
        const serviceUserMobile = new CepDataMobileService(this.handlerService);
        this.services.set(origin, serviceUserMobile);
        return serviceUserMobile;
      case DataOrigin.Mock:
        const serviceMock = new CepMockService();
        this.services.set(origin, serviceMock);
        return serviceMock;
      default:
        const serviceDefault = new CepMockService();
        this.services.set(origin, serviceDefault);
        return serviceDefault;
    }
  }
}
